import React from "react";
import Button from "Components/DesignSystem/Button/Button";
import { EditRuleInputPropType } from "../../Pages/DefineModel/model";

/* TODO(design-system): an input with an embedded trailing action has no DS
   control yet, so the composite keeps its bespoke shape on role tokens. */
const RuleInputComponent = ({
  ruleState,
  onChangeHandler,
  onSaveHandler,
  value,
  setInputRef,
}: EditRuleInputPropType) => {
  return (
    <div className="tw-rounded tw-bg-surface tw-box-border tw-w-[100%] tw-h-10 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-0.5 m-2 tw-gap-[2px] tw-text-sm tw-text-ink tw-border tw-border-solid tw-border-edge-strong">
      <input data-testid="rules-ruleinput-input-1"
        className="tw-h-8 tw-w-[95%] tw-bg-transparent tw-text-ink tw-pl-0"
        value={ruleState ?? value?.ruleExp}
        onChange={onChangeHandler}
        ref={(el) => setInputRef(el)}
      />
      <Button
        variant="primary"
        size="sm"
        className="tw-shrink-0"
        data-testid="rules-ruleinput-button-2"
        onClick={(e) => onSaveHandler(e, value ? "Edit" : "save")}
      >
        Done
      </Button>
    </div>
  );
};

export default RuleInputComponent;
